import toast from "react-hot-toast";
import * as api from "../Api/index";

export const getNewUnapprovedAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getNewAssets();
    dispatch({ type: "GET_NEW_UNAPPROVED_ASSETS", payload: data });
  } catch (error) {}
};
export const updateCompanyAsset = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    const { data } = await api.updateAsset(id, postData);
    dispatch({ type: "APPROVE_NEW_ASSET", payload: data });
    toast.remove(updatingId);
    toast.success("Changes saved successfully");
  } catch (error) {
    toast.remove(updatingId);
    toast.error(error.message);
  }
};

export const deleteNewAsset = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting asset...");
    await api.deleteNewAsset(id);
    dispatch({ type: "DELETE_NEW_ASSET", payload: id });
    toast.remove(deletingId);
    toast.success("Asset Successfully deleted");
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
